import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon39: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M0 1.62007C0 0.402074 1.29405 -0.378923 2.36005 0.185077L19.139 8.57106C20.287 9.17806 20.287 10.8251 19.129 11.4361L2.37 19.8121C1.294 20.3821 0 19.6001 0 18.3821L0.0360107 18.1971L3.30902 10.0011L0.0360107 1.80608L0 1.62007ZM1.90204 1.07405C1.51804 0.871054 1.06 1.12107 1.005 1.53707L4.18604 9.50106H12.23C12.476 9.50106 12.68 9.67806 12.722 9.91106L12.73 10.0011C12.73 10.2771 12.506 10.5011 12.23 10.5011H4.185L1.005 18.4651C1.056 18.8521 1.45503 19.0951 1.82703 18.9611L1.91205 18.9231L18.671 10.5471C19.109 10.3161 19.109 9.68707 18.681 9.46007L1.90204 1.07405Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
